import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getDashboardPath } from "../config/roleConfig";
import { getMeAdmin } from "../fitur/AuthSlice";

/**
 * Melindungi route berdasarkan sesi login dan daftar role yang diizinkan.
 */
const PrivateRoute = ({ children, allowedRoles, role }) => {
  const dispatch = useDispatch();
  const { user, isLoading, isError } = useSelector((state) => state.authAdmin);
  const roles = allowedRoles || (role ? [role] : null);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (!user && !fetchedRef.current) {
      fetchedRef.current = true;
      dispatch(getMeAdmin());
    }
  }, [dispatch, user]);

  if (!user) {
    if (isLoading || !isError) {
      return <div style={{ padding: 24, textAlign: "center" }}>Memuat...</div>;
    }
    return <Navigate to="/login" replace />;
  }

  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to={getDashboardPath(user.role)} replace />;
  }

  return children;
};

export default PrivateRoute;
